/* SIJL gedeelde configurator-helpers.
   Gebruikt door sections/sijl-bonbon-buy-box.liquid (productpagina) en
   sections/sijl-catalogus-samenstel-box.liquid (homepage/catalogus).
   Puur en DOM-agnostisch: paginaspecifieke selectors, state en teksten
   gaan er als parameters in. Wijzig gedeeld gedrag hier — één plek. */
(function() {
  'use strict';
  if (window.SijlShared) return;

  var confettiCallbacks = [];
  var confettiRequested = false;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Laadt het confetti-script (theme-asset) eenmalig; onReady wordt
     aangeroepen zodra window.confetti beschikbaar is. */
  function ensureConfetti(src, onReady) {
    if (typeof window.confetti === 'function') { if (onReady) onReady(); return; }
    if (onReady) confettiCallbacks.push(onReady);
    if (!src || confettiRequested) return;
    confettiRequested = true;
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.addEventListener('load', function() {
      while (confettiCallbacks.length) {
        var cb = confettiCallbacks.shift();
        try { cb(); } catch (e) {}
      }
    }, { once: true });
    document.head.appendChild(s);
  }

  /* Confetti-viering; respecteert prefers-reduced-motion.
     opts: { src, colors, particleCount, spread, originY } */
  function celebrate(opts) {
    opts = opts || {};
    if (prefersReducedMotion()) return;
    ensureConfetti(opts.src, function() {
      if (typeof window.confetti === 'function') {
        window.confetti({
          particleCount: opts.particleCount || 120,
          spread: opts.spread || 70,
          origin: { y: opts.originY || 0.65 },
          colors: opts.colors
        });
      }
    });
  }

  /* localStorage met timestamp + TTL. save voegt zelf ts toe;
     load geeft null bij ontbreken, parsefout of verlopen TTL. */
  var storage = {
    save: function(key, payload) {
      try {
        var record = Object.assign({ ts: Date.now() }, payload);
        window.localStorage.setItem(key, JSON.stringify(record));
      } catch (e) {}
    },
    load: function(key, ttl) {
      try {
        var data = JSON.parse(window.localStorage.getItem(key) || 'null');
        if (!data || (ttl && (Date.now() - data.ts) > ttl)) return null;
        return data;
      } catch (e) { return null; }
    },
    clear: function(key) {
      try { window.localStorage.removeItem(key); } catch (e) {}
    }
  };

  /* Gebalanceerde "verras mij"-wachtrij: shuffelt per chocoladegroep en
     deelt daarna round-robin uit zodat de mix gebalanceerd blijft.
     getGroup(card) levert de groepssleutel (bijv. wit/melk/puur). */
  function curatedQueue(cards, amount, getGroup) {
    var groups = {};
    cards.forEach(function(card) {
      var key = (getGroup(card) || '').trim() || 'overig';
      (groups[key] = groups[key] || []).push(card);
    });

    Object.keys(groups).forEach(function(key) {
      var arr = groups[key];
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
      }
    });

    var groupKeys = Object.keys(groups);
    var cursors = {};
    groupKeys.forEach(function(key) { cursors[key] = 0; });

    var queue = [];
    var g = 0;
    while (queue.length < amount && groupKeys.length) {
      var gk = groupKeys[g % groupKeys.length];
      var arr2 = groups[gk];
      queue.push(arr2[cursors[gk] % arr2.length]);
      cursors[gk]++;
      g++;
    }
    return queue;
  }

  /* Verkleint de tekst tot hij binnen (container-breedte * ratio) past —
     gebruikt voor de handgeschreven naam op de achterkant van het doosje. */
  function fitText(el, container, ratio, minSize) {
    if (!el || !container) return;
    el.style.fontSize = '';
    var avail = container.clientWidth * (ratio || 0.78);
    if (avail <= 0 || !el.textContent) return;
    var size = parseFloat(window.getComputedStyle(el).fontSize) || 20;
    var floor = minSize || 7;
    var guard = 0;
    while (el.scrollWidth > avail && size > floor && guard < 80) {
      size -= 1;
      el.style.fontSize = size + 'px';
      guard++;
    }
  }

  /* Koppelt de deel-knoppen (kopieer / WhatsApp / native share).
     cfg: { copyBtn, labelSelector, waBtn, nativeBtn, buildUrl, message, announce } */
  function wireShare(cfg) {
    var copyBtn = cfg.copyBtn;
    if (copyBtn) {
      var label = cfg.labelSelector ? copyBtn.querySelector(cfg.labelSelector) : null;
      copyBtn.addEventListener('click', function() {
        var url = cfg.buildUrl();
        var done = function() {
          copyBtn.classList.add('is-copied');
          if (label) label.textContent = 'Link gekopieerd!';
          if (cfg.announce) cfg.announce('Deel-link gekopieerd naar je klembord.');
          window.setTimeout(function() {
            copyBtn.classList.remove('is-copied');
            if (label) label.textContent = 'Kopieer de link';
          }, 2500);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function() { window.prompt('Kopieer je deel-link:', url); });
        } else {
          window.prompt('Kopieer je deel-link:', url);
        }
      });
    }

    if (cfg.waBtn) {
      cfg.waBtn.addEventListener('click', function() {
        window.open('https://wa.me/?text=' + encodeURIComponent(cfg.message()), '_blank', 'noopener');
      });
    }

    if (cfg.nativeBtn && navigator.share) {
      cfg.nativeBtn.hidden = false;
      cfg.nativeBtn.addEventListener('click', function() {
        navigator.share({
          title: 'Mijn SIJL bonbondoosje',
          text: 'Kijk wat ik heb samengesteld bij SIJL!',
          url: cfg.buildUrl()
        }).catch(function() {});
      });
    }
  }

  /* Warm-weer-check via Open-Meteo, met localStorage-cache (1 uur).
     Roept onWarm(maxTemp) aan als het maximum >= threshold is.
     cfg: { api, cacheKey, threshold, ttl } */
  function weather(cfg, onWarm) {
    var threshold = cfg.threshold || 24;
    var ttl = cfg.ttl || 3600000;

    function melden(max) {
      if (max >= threshold) onWarm(max);
    }

    var cached = storage.load(cfg.cacheKey, ttl);
    if (cached && typeof cached.max === 'number') {
      melden(cached.max);
      return;
    }

    fetch(cfg.api)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data || !data.daily || !data.daily.temperature_2m_max) return;
        var temps = data.daily.temperature_2m_max;
        var max = 0;
        for (var i = 0; i <= 2; i++) {
          if (temps[i] !== undefined && temps[i] > max) max = temps[i];
        }
        storage.save(cfg.cacheKey, { max: max });
        melden(max);
      })
      .catch(function() {});
  }

  window.SijlShared = {
    prefersReducedMotion: prefersReducedMotion,
    ensureConfetti: ensureConfetti,
    celebrate: celebrate,
    storage: storage,
    curatedQueue: curatedQueue,
    fitText: fitText,
    wireShare: wireShare,
    weather: weather
  };
})();
